/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MapJobWithAtsJobCommandDto interface.
 */
export function instanceOfMapJobWithAtsJobCommandDto(value) {
    if (!('jobId' in value) || value['jobId'] === undefined)
        return false;
    return true;
}
export function MapJobWithAtsJobCommandDtoFromJSON(json) {
    return MapJobWithAtsJobCommandDtoFromJSONTyped(json, false);
}
export function MapJobWithAtsJobCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'jobId': json['jobId'],
        'atsJobId': json['atsJobId'] == null ? undefined : json['atsJobId'],
    };
}
export function MapJobWithAtsJobCommandDtoToJSON(json) {
    return MapJobWithAtsJobCommandDtoToJSONTyped(json, false);
}
export function MapJobWithAtsJobCommandDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'jobId': value['jobId'],
        'atsJobId': value['atsJobId'],
    };
}
